import m from "mithril"
import ProjectCard from "./ProjectCard.js"

export default {
  view: function (vnode) {
    var projects = vnode.attrs.projects || []

    if (projects.length === 0) return null

    return m("section.portfolio-grid", { id: "portfolioGrid" },
      projects.map(function (p, i) {
        return m(ProjectCard, { key: p.id, project: p, index: i })
      })
    )
  },
}
